export default {
  methods: {
    differenceInTimeMinutes(startTime, endTime) {
      const startTimeSplit = startTime.split(":");
      const endTimeSplit = endTime.split(":");

      let startHour = parseFloat(startTimeSplit[0]);
      let startMinute = parseFloat(startTimeSplit[1]);
      let endHour = parseFloat(endTimeSplit[0]);
      let endMinute = parseFloat(endTimeSplit[1]);

      let start = startHour * 60 + startMinute;
      let end = endHour * 60 + endMinute;

      if (start > end) {
        endHour += 24;
        end = endHour * 60 + endMinute;
      }

      return end - start;
    },

    timeInBed(data) {
      return this.differenceInTimeMinutes(data.timeToBed, data.outBedTime);
    },

    totalSleepTime(data) {
      const morningTime = this.differenceInTimeMinutes(
        data.wakeUpTime,
        data.outBedTime
      );

      return (
        this.timeInBed(data) -
        (parseInt(data.timeToSleep) +
          parseInt(data.awakeTime) +
          parseInt(morningTime))
      );
    },

    sleepEfficiency(data) {
      return Math.round(
        (this.totalSleepTime(data) / this.timeInBed(data)) * 100
      );
    }
  }
};
